/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/*

document.querySelector('#lettere-container span').onclick = function () { 
console.log('prova' +this.id);


  
  const id = 'no-z';
const yOffset = -120; 
const element = document.getElementById(id);
const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

window.scrollTo({top: y, behavior: 'smooth'});
  


};*/







/** Add tracking for mail e tel */
document.addEventListener("DOMContentLoaded", function () {
  let locale = Shopify.locale;
  if (locale=='it'){
    locale = 'ita';
  }	else	{
      locale = 'eng';
    }
    
    var elements = document.querySelectorAll("a[href^='tel:']"),
        l = elements.length;
    for (var i = 0; i < l; ++i) {
        elements[i].addEventListener("click", function () {

           gtag('event', 'clic', {
              'event_category': 'tel',
              'event_label': locale
            });
          
        });
    }
  
  var elements = document.querySelectorAll("a[href^='mailto:']"),
        l = elements.length;
    for (var i = 0; i < l; ++i) {
        elements[i].addEventListener("click", function () {
           gtag('event', 'clic', {
              'event_category': 'mail',
              'event_label': locale
            });
          
        });
    }
  
}, false);


//cambia da iniziali a incisione

document.addEventListener("DOMContentLoaded", function() {
    var elements = document.querySelectorAll(".ProductForm__Label");

    elements.forEach(function(element) {
        if (element.textContent.includes('Incisione:')) {
          if (window.Shopify.country=='IT'){
            element.innerHTML = element.innerHTML.replace(/Incisione:/g, 'Iniziali:');
          }else
          {
            element.innerHTML = element.innerHTML.replace(/Incisione:/g, 'Initials:');

          }
        }
    });
});
